<template>
  <v-container class="fill-height" style="opacity: 0.94" fluid>
    <v-sheet elevation="1" rounded width="100%" class="mt-16 mb-8">
      <deprecation-banner />
      <EngravingMaskToolbar
        :num-parts="numParts"
        :direction="direction"
        :shape="shape"
        :spacing="spacing"
        :output-size="outputSize"
        @update:num-parts="numParts = $event"
        @update:direction="direction = $event"
        @update:shape="shape = $event"
        @update:spacing="spacing = $event"
        @update:output-size="outputSize = $event"
      />
      <v-row align="stretch" class="engraving-mask-sections px-4 pb-6">
        <v-col cols="12" md="4" class="engraving-mask-left d-flex flex-column align-center justify-center">
          <p class="text-body-2 text--secondary mb-4 text-center">
            Choose number of images (1, 2, or 3), shape, then upload and adjust each part.
            Adjust position, rotation, and zoom for each image, then download the mask result.
          </p>
          <v-btn
            color="primary"
            :disabled="!downloadReady"
            @click="$refs.maskEditor && $refs.maskEditor.download()"
          >
            <v-icon left>mdi-download</v-icon>
            Download mask image
          </v-btn>
        </v-col>
        <v-col cols="12" md="8" class="engraving-mask-right d-flex align-center justify-center">
          <EngravingMaskEditor
            ref="maskEditor"
            :num-parts="numParts"
            :direction="direction"
            :shape="shape"
            :output-size="outputSize"
            :spacing="spacing"
            @can-download-change="downloadReady = $event"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import {
  EngravingMaskEditor,
  EngravingMaskToolbar,
  NUM_PARTS_OPTIONS,
  DIRECTION_OPTIONS,
  SHAPE_OPTIONS,
  SIZE_OPTIONS,
  SPACING_OPTIONS,
  DEFAULT_OUTPUT_SIZE,
} from '../components/EngravingMask'
import DeprecationBanner from '../components/DeprecationBanner.vue'

export default {
  name: 'MizodiaEngravingMask',
  components: { EngravingMaskToolbar, EngravingMaskEditor, DeprecationBanner },
  data() {
    return {
      downloadReady: false,
      numParts: 2,
      shape: 'circle',
      outputSize: DEFAULT_OUTPUT_SIZE,
      spacing: 0,
      direction: 'horizontal',
      numPartsOptions: NUM_PARTS_OPTIONS,
      directionOptions: DIRECTION_OPTIONS,
      shapeOptions: SHAPE_OPTIONS,
      sizeOptions: SIZE_OPTIONS,
      spacingOptions: SPACING_OPTIONS,
    }
  },
}
</script>

<style scoped>
.engraving-mask-sections {
  min-height: 420px;
}

.engraving-mask-left {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

@media (max-width: 959px) {
  .engraving-mask-left {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 1.5rem;
  }
}
</style>
